import { SLOTS_APIS } from "@/api_framework/api_config";
import {
  IBookingServicePricingRequestParams,
  IBookingServicePricingResponse,
  IBookingServicePricingResponseData,
} from "@/api_framework/api_modals/Bookings";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});

export const useBookingServicePricingAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [isServicePricingInProgress, setIsServicePricingInProgress] = useState(false);
  const [servicePricingData, setServicePricingData] = useState<IBookingServicePricingResponseData | null>(null);

  const execute = useCallback(
    async (params: IBookingServicePricingRequestParams) => {
      if (!params?.sub_service_id || !params?.clinic_id || !params?.user_id || !params?.pet_id) {
        setServicePricingData(null);
        return null;
      }

      setIsServicePricingInProgress(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .get(SLOTS_APIS?.SERVICE_PRICING?.baseURL ?? "", {
            params,
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IBookingServicePricingResponse>) => {
            if (res.data.status && res.data.data) {
              setServicePricingData(res.data.data);
              return res.data.data;
            }
            setServicePricingData(null);
            return null;
          })
          .catch((e: AxiosError) => {
            if (e.config?.["curlCommand"]) {
              sendCurl(e.config["curlCommand"]);
            }
            setServicePricingData(null);
            return null;
          });

        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        setServicePricingData(null);
        return null;
      } finally {
        setIsServicePricingInProgress(false);
      }
    },
    [configuration, sendCurl],
  );

  return {
    execute,
    isServicePricingInProgress,
    servicePricingData,
  };
};
